import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {getLegacyCrmFieldValueById} from '@components/crm/default-data-fields'
import {TableColumn} from '../common/base/table'
import {DealActivityDoneButton} from '../right-panel/crm/deal-history/deal-time-line-message/deal-activity-done-button'
import {RowData} from './common'
import {customFormatDate} from './custom-format-date'
import {getDealActivityColor} from './get-deal-activity-color'

const renderDoneColumn = (row: RowData) => (
  <div className="flex justify-center items-center w-full">
    <DealActivityDoneButton
      activity={{
        id: row.id as DataObjectId,
        completed: row.activity.completed
      }}
      deal={row.task}
    />
  </div>
)

const TwCell = tw.div`
  flex
  justify-start
  items-center
  w-full
  text-ellipsis
  overflow-hidden
  whitespace-nowrap
`

const renderActivityColumn = (row: RowData) => {
  const textColor = getDealActivityColor(row.activity)
  return <TwCell className={`${textColor}`}>{row.activity.text}</TwCell>
}

const renderCompanyColumn = (row: RowData) => (
  <TwCell>{row.organization?.title}</TwCell>
)

const renderTaskColumn = (row: RowData) => <TwCell>{row.task?.title}</TwCell>

const renderDeadlineColumn = (row: RowData) => (
  <TwCell>{customFormatDate(row.activity.deadline)}</TwCell>
)

const renderContactPersonColumn = (row: RowData) => (
  <TwCell>{row.contactPerson?.title}</TwCell>
)

const renderPhoneColumn = (row: RowData) => (
  <TwCell>
    {row.contactPerson?.data?.fieldValues?.['contact-phone'] ??
      getLegacyCrmFieldValueById(row.contactPerson?.data, 'contact-phone') ??
      ''}
  </TwCell>
)

const renderEmailColumn = (row: RowData) => (
  <TwCell>
    {row.contactPerson?.data?.fieldValues?.['contact-email'] ??
      getLegacyCrmFieldValueById(row.contactPerson?.data, 'contact-email') ??
      ''}
  </TwCell>
)

export const getCrmActivitiesColumns = (): TableColumn<RowData>[] => {
  return [
    {
      id: 'done',
      title: Lang.msg.crm.activitiesView.table.done,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderDoneColumn,
      width: 75,
      minWidth: 75,
      maxWidth: 75
    },
    {
      id: 'activity',
      title: Lang.msg.crm.activitiesView.table.activity,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderActivityColumn,
      width: 183,
      minWidth: 183,
      maxWidth: 250
    },
    {
      id: 'company',
      title: Lang.msg.crm.activitiesView.table.company,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderCompanyColumn,
      width: 179,
      minWidth: 179,
      maxWidth: 179
    },
    {
      id: 'task',
      title: Lang.msg.crm.activitiesView.table.task,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderTaskColumn,
      width: 156,
      minWidth: 156,
      maxWidth: 156
    },
    {
      id: 'deadline',
      title: Lang.msg.crm.activitiesView.table.deadline,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderDeadlineColumn,
      width: 122,
      minWidth: 122,
      maxWidth: 122
    },
    {
      id: 'contactPerson',
      title: Lang.msg.crm.activitiesView.table.contactPerson,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderContactPersonColumn,
      width: 132,
      minWidth: 132,
      maxWidth: 132
    },
    {
      id: 'phone',
      title: Lang.msg.crm.activitiesView.table.phone,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderPhoneColumn,
      width: 151,
      minWidth: 151,
      maxWidth: 151
    },
    {
      id: 'email',
      title: Lang.msg.crm.activitiesView.table.email,
      className: '!px-12 !py-8 cursor-pointer',
      render: renderEmailColumn,
      width: 171,
      minWidth: 171,
      maxWidth: 171
    }
  ]
}
